// extracted by mini-css-extract-plugin
module.exports = {"flag":"styles_flag__1QFTA","countrySelecter":"styles_countrySelecter__2AE_7","amountInput":"styles_amountInput__1nKsR"};